import { render, staticRenderFns } from "./role_permission.vue?vue&type=template&id=4cc11730&scoped=true&"
import script from "./role_permission.vue?vue&type=script&lang=ts&"
export * from "./role_permission.vue?vue&type=script&lang=ts&"
import style0 from "./role_permission.vue?vue&type=style&index=0&id=4cc11730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc11730",
  null
  
)

export default component.exports